import * as React from 'react';
import * as navigate from 'app/area/shared/navigation';
import { TabItemWrapperProps, ViewMode } from 'app/components/metro-line/types';
import { TabItem } from 'app/components/tabs/tab-item/tab-item';
import { scrollIntoView } from 'app/infrastructure/platform/browser-dom';

export class TabItemWrapper<SectionType> extends React.PureComponent<TabItemWrapperProps<SectionType>> {

  private onClick = (e: React.MouseEvent) => {
    e.preventDefault();
    this.props.activeMode === ViewMode.scroll ? this.scrollToSection() : this.navigateToSection();
  };

  private scrollToSection = () => {
    const { itemRef, anchorId } = this.props;
    const ref = !!itemRef && !!itemRef.current ? itemRef.current : null;

    if (!ref) {
      return;
    }

    const anchor = document.getElementById(anchorId);
    scrollIntoView(anchor, { behavior: 'smooth' });
  };

  private navigateToSection = () => {
    const { item, updateActiveSection } = this.props;

    navigate.toMetroLineSection(item.url);

    updateActiveSection(item.section);
  };

  public render() {

    const { id, item, active, valid, warnings, translation } = this.props;

    return <TabItem
      id={id}
      active={active}
      valid={valid}
      warnings={warnings}
      url={undefined}
      label={{ text: item.label(translation) }}
      iconUrl={item.iconUrl}
      onClick={this.onClick}
      visible={item.visible}
    />;
  }
}
